<template>
  <div>
    <div>
      <h4>You have to verify your email address!</h4>
      <div class="mt-4">
          <span style="border-radius: 2px; background-color: rgba(33, 33, 33, 0.08); padding: 0.3rem 0.5rem;">{{ email }}</span>
      </div>
      <p class="mt-4">Please check your inbox to find the verification email and enter the verification code to access your account! If you don't see the email in your inbox, please check your spam folder.</p>
    </div>
    <b-form method="post" :action="verificationUrl">
      <b-form-group label="Enter the verification code" aria-label="Verification code">
        <b-form-input name="csrfmiddlewaretoken" hidden :value="csrftoken"></b-form-input>
        <b-form-input name="verification_key" hidden :value="vkey"></b-form-input>
        <b-form-input name="verification_code" placeholder="xxxxxx" aria-label="Enter your verification code"></b-form-input>
        <b-button type="submit" variant="info" class="mt-4">Verify email address</b-button>
      </b-form-group>
    </b-form>

    <div class="d-flex flex-column align-items-end">
      <small><strong>Didn't receive the email?</strong></small>
      <small><a class="resend_a" @click="resendVerificationCode">Click here to resend it</a></small>
    </div>
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
import { errorHandling } from '@/js/custom-vue-mixins';

  export default {
    name: 'VerifyEmailAddressWithCode',
    components: {},
    mixins: [errorHandling],
    props: {
      csrftoken: {
        type: String,
        required: true,
      },
      vkey: {
        type: String,
        required: true,
      },
      email: {
        type: String,
        required: true,
      },
      nexturl: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
      redirectUrl: function () {
        return this.nexturl && this.nexturl !== '' ? `?next=${this.nexturl}` : '';
      },
      verificationUrl: function () {
        return `${window.splUrlMap.finish_verification_code_base}${this.redirectUrl}`;
      },
    },
    mounted: function() {
        suppliosApi.auth.getLoginMethods();
    },
    methods: {
      async resendVerificationCode() {
        try {
          await suppliosApi.auth.resendVerificationEmail(this.vkey);
          this.$toast.success('Verification email has been resent');
        } catch (error) {
          this.apiErrorHandler(error, "Error while resending verification email. Please try again later.");
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
    .resend_a:hover {
        color: #007bff;
        cursor: pointer;
    }
</style>
